import { BooleanField, BooleanInput, Create, Datagrid, DateField, Edit, EmailField, List, PasswordInput, ReferenceField, SimpleForm, TextField, TextInput } from 'react-admin';

export const AdministratorList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <EmailField source="email" />
            <TextField source="name" />
            <BooleanField source="status" />
            <DateField source="createdAt" />
            <TextField source="updatedAt" />
            <ReferenceField source="updatedBy" reference="administrators">
                <TextField source="email" />
             </ReferenceField>
        </Datagrid>
    </List>
);

export const AdministratorEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="email" fullWidth required />
            <TextInput source="name" fullWidth required />
            <PasswordInput source="password" fullWidth required />
            <BooleanInput source="status" />
        </SimpleForm>
    </Edit>
);

export const AdministratorCreate = (props: any) => {
    return (
        <Create title='Administrator'>
            <SimpleForm>
                <TextInput source="email" fullWidth required />
                <TextInput source="name" fullWidth required />
                <PasswordInput source="password" fullWidth required />
                <BooleanInput source="status" defaultValue={ true }/>
            </SimpleForm>
        </Create>
    )
}